import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import SectionCard from "../../components/SectionCard";
import SectionRow from "../../components/SectionRow";
import { useCustomFields } from "features/Settings/CustomFields/context";
import { renderSettingsResourceLabel } from "utils/helpers/settings";

function CustomFields({ user }: any) {
    const { t } = useTranslation();
    const { peopleCustomFields } = useCustomFields();

    const customFieldsValues = useMemo(
        () => peopleCustomFields?.filter((field: any) => !!user?.customFields?.[field?.code]),
        [peopleCustomFields, user?.customFields],
    );

    if (!customFieldsValues?.length) return null;

    return (
        <SectionCard title={t("custom-fields")}>
            {customFieldsValues.map((field: any) => (
                <SectionRow
                    key={field.code}
                    label={renderSettingsResourceLabel(field)}
                    value={user?.customFields[field.code]}
                />
            ))}
        </SectionCard>
    );
}

export default CustomFields;
